import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';

import { Dropdown } from '~sharedComponents/Dropdown/Dropdown';

const { space12 } = ContentSpacing;

export const StyledDropdown = styled(Dropdown)`
    border-radius: 0;
    padding: ${space12};
    width: 100%;
`;
